import './Image.css';

import { Img } from 'react-image';

const Image = (props) => {
    return <Img src={props.src}
        loader={<div className="img-placeholder"></div>}
        unloader={<div className="img-placeholder"></div>} />
}

export default Image